import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';

export const useMealPlanShoppingListMacrosEnabled = (): boolean => {
  return useFeatureIsOn(
    GROWTHBOOK_FEATURE_FLAGS.MEAL_PLAN_SHOPPING_LIST_MACROS,
  );
};
